import { forwardRef, type LabelHTMLAttributes } from 'react';

export type LabelProps = LabelHTMLAttributes<HTMLLabelElement>;

export const Label = forwardRef<HTMLLabelElement, LabelProps>(function Label(
  { className, ...rest },
  ref,
) {
  const cls = ['text-sm font-medium text-fg', className ?? ''].filter(Boolean).join(' ');
  return <label ref={ref} className={cls} {...rest} />;
});
